import React from "react";
export const Recruiterjob=()=>{
    return(
        <>
       <h1> recruiter job page  </h1>
        </>
    )
}